import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  foilIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      width: 23,
      height: 23,
    },
  },
}));

export default useStyles;
